import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  width: 380px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  padding: 24px 24px 0 24px;
`;

export const ModalTitle = styled.h2`
  font-family: "Inter";
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #1a1a1a;
  margin: 0 0 4px 0;
`;

export const ModalDescription = styled.p`
  font-family: "Inter";
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #6b7280;
  margin: 0;
`;

export const ModalBody = styled.div`
  padding: 16px 24px;
  overflow-y: auto;
  flex: 1;
`;

export const CheckboxItem = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #2d5bff;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
`;

export const CheckboxLabel = styled.span`
  font-family: "Inter";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1a1a1a;
`;

export const ModalFooter = styled.div`
  padding: 16px 24px 24px 24px;
`;

export const ExportButton = styled.button`
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #2d5bff 0%, #00c896 100%);
  color: #ffffff;
  font-family: "Inter";
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
